import { SagaIterator } from "redux-saga";
import { call, put, takeEvery } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setDeleteQuizError, setLoading } from "../../repository/slice";

function* deleteQuizWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const url = payload.mode ? `/api/admin/questionnaires/${payload.id}/hard` : `/api/admin/questionnaires/${payload.id}`
        const { data, message, isError }: IResponse<any> = yield call(requester.delete, url);
        if (isError) {
            yield put(setDeleteQuizError(message));
        } else {
            yield put(setDeleteQuizError(null));
        }
    } catch (error) {
        console.error("deleteQuizWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* deleteQuizWatcher() {
    yield takeEvery("@saga/DELETE_QUIZ", deleteQuizWorker);
};
